var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "labor-screening padding24" },
    [
      _c(
        "div",
        { staticClass: "print-button-container marginB-24" },
        [
          _c(
            "b-button",
            { attrs: { variant: "primary" }, on: { click: _vm.printForm } },
            [_vm._v("Print Form")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "marginB-1em" }, [
        _vm._v(
          "\n        Louisiana Indicator Tool for Child & Youth Labor Trafficking\n    "
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.detailFields, function(item, id) {
        return _c(
          "p",
          { key: id, staticClass: "labor-screening__description" },
          [
            _c(
              "span",
              {
                staticClass:
                  "labor-screening__description labor-screening__description--bold"
              },
              [_vm._v("\n            " + _vm._s(item.title) + ":\n        ")]
            ),
            _vm._v("\n        " + _vm._s(item.value) + "\n    ")
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "labor-screening__table" },
        [
          _c(
            "b-row",
            { staticClass: "labor-screening__row" },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--bold"
                  },
                  [_vm._v("\n                    ENDS\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--italic marginB0"
                  },
                  [
                    _vm._v(
                      "\n                    The ends of the crime refer to the specific type of victimization that the child or youth is experiencing.\n                "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                Did the child or youth engage in labor or services against their will, or were they forced to work to pay off debt?"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "labor-screening__header labor-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                        Forced Labor\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "labor-screening__checkbox-group" },
                      [
                        _vm._l(
                          Object.entries(_vm.endsLaborFields["FORCED_LABOR"]),
                          function(ref) {
                            var key = ref[0]
                            var value = ref[1]
                            return _c(
                              "b-form-checkbox",
                              {
                                key: key,
                                staticClass: "labor-screening__checkbox",
                                model: {
                                  value: _vm.laborScreening[key],
                                  callback: function($$v) {
                                    _vm.$set(_vm.laborScreening, key, $$v)
                                  },
                                  expression: "laborScreening[key]"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(value.desc) +
                                    "\n                        "
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "labor-screening__checkbox",
                            model: {
                              value: _vm.laborScreeningOther.e_fl_otherText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.laborScreeningOther,
                                  "e_fl_otherText",
                                  $$v
                                )
                              },
                              expression: "laborScreeningOther.e_fl_otherText"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Other:\n                            "
                            ),
                            _c("b-form-input", {
                              staticClass: "labor-screening__form-input",
                              model: {
                                value: _vm.laborScreening.e_fl_otherText,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.laborScreening,
                                    "e_fl_otherText",
                                    $$v
                                  )
                                },
                                expression: "laborScreening.e_fl_otherText"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "labor-screening__header labor-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                        Debt Bondage\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "labor-screening__checkbox-group" },
                      [
                        _vm._l(
                          Object.entries(_vm.endsLaborFields["DEBT_BONDAGE"]),
                          function(ref) {
                            var key = ref[0]
                            var value = ref[1]
                            return _c(
                              "b-form-checkbox",
                              {
                                key: key,
                                staticClass: "labor-screening__checkbox",
                                model: {
                                  value: _vm.laborScreening[key],
                                  callback: function($$v) {
                                    _vm.$set(_vm.laborScreening, key, $$v)
                                  },
                                  expression: "laborScreening[key]"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(value.desc) +
                                    "\n                        "
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "labor-screening__checkbox",
                            model: {
                              value: _vm.laborScreeningOther.e_db_otherText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.laborScreeningOther,
                                  "e_db_otherText",
                                  $$v
                                )
                              },
                              expression: "laborScreeningOther.e_db_otherText"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Other:\n                            "
                            ),
                            _c("b-form-input", {
                              staticClass: "labor-screening__form-input",
                              model: {
                                value: _vm.laborScreening.e_db_otherText,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.laborScreening,
                                    "e_db_otherText",
                                    $$v
                                  )
                                },
                                expression: "laborScreening.e_db_otherText"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--bold"
                  },
                  [_vm._v("\n                    MEANS\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "\n                    The means refers to the methods of force, fraud, and coercion a perpetrator uses to keep the child or youth in a trafficking situation.\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "What did the perpetrator do (or threaten to do) to ensure that the child or youth provided labor or services?"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "labor-screening__header labor-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                        Coercion (psychological, mental, or emotional control)\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "labor-screening__checkbox-group" },
                      [
                        _vm._l(
                          Object.entries(_vm.meansLaborFields["COERCION"]),
                          function(ref) {
                            var key = ref[0]
                            var value = ref[1]
                            return _c(
                              "b-form-checkbox",
                              {
                                key: key,
                                staticClass: "labor-screening__checkbox",
                                model: {
                                  value: _vm.laborScreening[key],
                                  callback: function($$v) {
                                    _vm.$set(_vm.laborScreening, key, $$v)
                                  },
                                  expression: "laborScreening[key]"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(value.desc) +
                                    "\n                        "
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "labor-screening__checkbox",
                            model: {
                              value: _vm.laborScreeningOther.m_c_otherText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.laborScreeningOther,
                                  "m_c_otherText",
                                  $$v
                                )
                              },
                              expression: "laborScreeningOther.m_c_otherText"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Other:\n                            "
                            ),
                            _c("b-form-input", {
                              staticClass: "labor-screening__form-input",
                              model: {
                                value: _vm.laborScreening.m_c_otherText,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.laborScreening,
                                    "m_c_otherText",
                                    $$v
                                  )
                                },
                                expression: "laborScreening.m_c_otherText"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "labor-screening__header labor-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                       Fraud (tricked, lied to, or defrauded)\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "labor-screening__checkbox-group" },
                      [
                        _vm._l(
                          Object.entries(_vm.meansLaborFields["FRAUD"]),
                          function(ref) {
                            var key = ref[0]
                            var value = ref[1]
                            return _c(
                              "b-form-checkbox",
                              {
                                key: key,
                                staticClass: "labor-screening__checkbox",
                                model: {
                                  value: _vm.laborScreening[key],
                                  callback: function($$v) {
                                    _vm.$set(_vm.laborScreening, key, $$v)
                                  },
                                  expression: "laborScreening[key]"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(value.desc) +
                                    "\n                        "
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "labor-screening__checkbox",
                            model: {
                              value: _vm.laborScreeningOther.m_fr_otherText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.laborScreeningOther,
                                  "m_fr_otherText",
                                  $$v
                                )
                              },
                              expression: "laborScreeningOther.m_fr_otherText"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Other:\n                            "
                            ),
                            _c("b-form-input", {
                              staticClass: "labor-screening__form-input",
                              model: {
                                value: _vm.laborScreening.m_fr_otherText,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.laborScreening,
                                    "m_fr_otherText",
                                    $$v
                                  )
                                },
                                expression: "laborScreening.m_fr_otherText"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "labor-screening__header labor-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                       Force (physical control or restraint)\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "labor-screening__checkbox-group" },
                      [
                        _vm._l(
                          Object.entries(_vm.meansLaborFields["FORCE"]),
                          function(ref) {
                            var key = ref[0]
                            var value = ref[1]
                            return _c(
                              "b-form-checkbox",
                              {
                                key: key,
                                staticClass: "labor-screening__checkbox",
                                model: {
                                  value: _vm.laborScreening[key],
                                  callback: function($$v) {
                                    _vm.$set(_vm.laborScreening, key, $$v)
                                  },
                                  expression: "laborScreening[key]"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(value.desc) +
                                    "\n                        "
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "labor-screening__checkbox",
                            model: {
                              value: _vm.laborScreeningOther.m_fo_otherText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.laborScreeningOther,
                                  "m_fo_otherText",
                                  $$v
                                )
                              },
                              expression: "laborScreeningOther.m_fo_otherText"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Other:\n                            "
                            ),
                            _c("b-form-input", {
                              staticClass: "labor-screening__form-input",
                              model: {
                                value: _vm.laborScreening.m_fo_otherText,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.laborScreening,
                                    "m_fo_otherText",
                                    $$v
                                  )
                                },
                                expression: "laborScreening.m_fo_otherText"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--bold"
                  },
                  [_vm._v("\n                    PROCESS\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "\n                    The 'process' refers to the actions the perpetrator takes to compel the child or youth into a trafficking situation.\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "labor-screening__header labor-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "What were the intentional acts the perpetrator took to get the child or youth in the situation?"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "div",
                      { staticClass: "labor-screening__checkbox-group" },
                      [
                        _vm._l(Object.entries(_vm.processLaborFields), function(
                          ref
                        ) {
                          var key = ref[0]
                          var value = ref[1]
                          return _c(
                            "b-form-checkbox",
                            {
                              key: key,
                              staticClass: "labor-screening__checkbox",
                              model: {
                                value: _vm.laborScreening[key],
                                callback: function($$v) {
                                  _vm.$set(_vm.laborScreening, key, $$v)
                                },
                                expression: "laborScreening[key]"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(value.desc) +
                                  "\n                        "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "labor-screening__checkbox",
                            model: {
                              value: _vm.laborScreeningOther.p_otherText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.laborScreeningOther,
                                  "p_otherText",
                                  $$v
                                )
                              },
                              expression: "laborScreeningOther.p_otherText"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Other:\n                            "
                            ),
                            _c("b-form-input", {
                              staticClass: "labor-screening__form-input",
                              model: {
                                value: _vm.laborScreening.p_otherText,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.laborScreening,
                                    "p_otherText",
                                    $$v
                                  )
                                },
                                expression: "laborScreening.p_otherText"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "labor-screening__container" }, [
        _c(
          "span",
          {
            staticClass:
              "labor-screening__header labor-screening__description--bold"
          },
          [_vm._v("\n            Conclusion:\n        ")]
        ),
        _vm._v(" "),
        _c("p", { class: _vm.laborScreeningConclusionClasses }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.LABOR_CONCLUSION_LABEL_MAP[this.laborScreening.conclusion]
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _vm.laborScreening.conclusion ===
        _vm.LABOR_SCREENING_CONCLUSION.NOT_ENOUGH_INFO
          ? _c("div", { staticClass: "mb-0" }, [
              _c("p", [
                _vm._v(
                  "If there is one checkbox in one of the categories or no boxes checked, there is not enough information to determine the child or youth is a potential victim of labor trafficking."
                )
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _vm.laborScreening.conclusion ===
            _vm.LABOR_SCREENING_CONCLUSION.LEVEL1
          ? _c("div", { staticClass: "mb-0" }, [
              _c("p", [
                _vm._v(
                  "If there is at least one checkbox in at least two of the categories, there is concern that the child or youth could potentially be a victim of labor trafficking."
                )
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _vm.laborScreening.conclusion ===
            _vm.LABOR_SCREENING_CONCLUSION.LEVEL2
          ? _c("div", { staticClass: "mb-0" }, [
              _c("p", [
                _vm._v(
                  'If there is at least one checkbox in all three categories (Ends, Means, Process), the child or youth meets the state definition of human trafficking and is considered "indicated" for labor trafficking.'
                )
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6)
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "Action to be taken: Continue to monitor the child or youth. Follow mandatory reporting guidelines if you suspect abuse or neglect to a child under 18 years of age by a parent or caretaker. If you suspect a crime has occurred or the child or youth is in immediate danger, report to law enforcement."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "Action to be taken: Immediately report to law enforcement if you suspect a crime has occurred or the child or youth is in immediate danger. If you suspect child abuse or neglect to a child under 18 years of age by a parent or caretaker, call the "
        ),
        _c(
          "a",
          { attrs: { href: "https://www.dcfs.la.gov/", target: "_blank" } },
          [_vm._v("DCFS")]
        ),
        _vm._v(
          " Child Abuse/Neglect Hotline at 855-452-5437. Refer to services for additional assessment by contacting the National Human Trafficking Hotline at 888-373-7888 or by referring to "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://humantrafficking.la.gov/resources/",
              target: "_blank"
            }
          },
          [_vm._v("a local service provider")]
        ),
        _vm._v(" with expertise in human trafficking.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "Action to be taken: Immediately report to law enforcement. If you suspect child abuse or neglect to a child under 18 years of age by a parent or caretaker, call the "
        ),
        _c(
          "a",
          { attrs: { href: "https://www.dcfs.la.gov/", target: "_blank" } },
          [_vm._v("DCFS")]
        ),
        _vm._v(
          " Child Abuse/Neglect Hotline at 855-452-5437. Refer the child to Care Coordination by emailing "
        ),
        _c("a", { attrs: { href: "mailto:carecoordination@lacacs.org" } }, [
          _vm._v("carecoordination@lacacs.org")
        ]),
        _vm._v(" and attach a copy of the screening tool.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "If the child is a non-U.S. citizen or non-lawful permanent resident, report to "
        ),
        _c(
          "a",
          { attrs: { href: "https://www.acf.hhs.gov/otip", target: "_blank" } },
          [_vm._v("HHS Office of Trafficking in Persons (OTIP)")]
        ),
        _vm._v(" by submitting a Request for Assistance (RFA) through "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://atims.acf.hhs.gov/eaasidentityserver/Identity/Account/Login/LoginSelection/",
              target: "_blank"
            }
          },
          [_vm._v("Shepherd")]
        ),
        _vm._v(
          ". (Contact the OTIP Child Protection Specialists by phone at 202-205-4582 or email at "
        ),
        _c("a", { attrs: { href: "mailto:ChildTrafficking@acf.hhs.gov" } }, [
          _vm._v("ChildTrafficking@acf.hhs.gov")
        ]),
        _vm._v(
          ".) Also consider referring the child/youth to an attorney to help assess qualifications for legal relief as a potential trafficking victim."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "If the individual is a youth, or aged 18 years or older, provide the individual with the National Human Trafficking Hotline at 888-373-7888 and offer to make a referral to "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://humantrafficking.la.gov/resources/",
              target: "_blank"
            }
          },
          [_vm._v("a local service provider")]
        ),
        _vm._v(
          " with expertise in human trafficking. If the individual is an adult with a disability, report also to Adult Protective Services at 800-898-4910."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "Update the Victim Status for the child or youth and complete the requested information."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "Please note: This tool does not include a result for a confirmed victim of human trafficking. If you receive certification of the child or youth being a confirmed victim of trafficking after completing the screening, you must update their victim status to “confirmed.” A trafficking event is considered “confirmed” when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in La. RS 14:46.2, La. RS 14:46.3, or the federal Trafficking Victims Protection Act (TVPA). While the tool does provide indicators to meet the state legal definition of trafficking, the tool is insufficient alone to weigh the totality of evidence or to replace the assessment of qualified professionals (such as, law enforcement, U.S. Attorney, District Attorney, HHS, victim advocate, Care Coordinator, or other qualified professional.)"
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e89f9fb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e89f9fb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/PrintLaborScreening.vue
// module id = 1768
// module chunks = 0